import(/* webpackMode: "eager" */ "/vercel/path0/app/categories/page.js");
